import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { getAppInfo } from './appInfo';
import { ChangePasswordCredential, ChangePasswordResponse } from '../../types';

type Params = {
  credential: ChangePasswordCredential;
  password: string;
  url: string;
};

/**
 * `POST /auth/recoverPassword` de NestJS, para los dos cambios de contraseña.
 *
 * A diferencia del Java al que sustituye, responde con códigos HTTP reales:
 * `200` si se actualizó, `401` si la credencial no sirve, `422` si la
 * contraseña está en el historial y `400` si el cuerpo no cumple. `unwrap`
 * rechaza en todos los que no son `200`.
 *
 * La contraseña viaja en claro, como en el ingreso: el SHA256 era un requisito
 * del servicio de Java.
 */
export const resetPasswordApi = createApi({
  reducerPath: 'resetPasswordApi',
  baseQuery: fetchBaseQuery(),
  endpoints: builder => ({
    resetPassword: builder.mutation<ChangePasswordResponse, Params>({
      query: ({ credential, password, url }) => ({
        url,
        method: 'POST',
        body:
          credential.kind === 'passwordChangeToken'
            ? { passwordChangeToken: credential.passwordChangeToken, password }
            : {
                password,
                appInfo: {
                  ...getAppInfo(credential.sessionToken),
                  refreshToken: credential.refreshToken,
                },
              },
      }),
    }),
  }),
});

export const { useResetPasswordMutation } = resetPasswordApi;
